var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("emc-card-stats", {
    attrs: {
      color: "blue darken-2",
      icon: "mdi-flask-outline",
      "icon-large": "",
      title: _vm.title,
      value: _vm.ambiences,
      "sub-text": "Número de ambientes",
    },
    scopedSlots: _vm._u([
      {
        key: "tools",
        fn: function () {
          return [
            _c("emc-chart-refresh-status", {
              attrs: {
                label: _vm.statusLabel,
                failed: _vm.hasFailed,
                "error-code": _vm.errorCode,
              },
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("emc-button-icon", {
              attrs: {
                "btn-small": "",
                disabled: _vm.isBusy,
                icon: "mdi-refresh-circle",
                text: _vm.updated_at || `Atualizar`,
                color: "success",
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.start()
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }